// src/bug.ts
import { enqueue } from './transport';
import type { BugPayload } from './types';
import { now } from './utils';
import { getSessionIdSafe, getUserIdSafe, getScreenshotConfigSafe } from './core';
import { captureScreenshotFromTag } from './screenshot';

export function reportBug(payload: {
    title: string; description?: string;
    severity?: 'blocker'|'major'|'minor'|'ux';
    attachments?: Blob[];
}) {
    const sessionId = getSessionIdSafe();
    if (!sessionId) return;
    const screenshotCfg = getScreenshotConfigSafe();
    const shouldCapture = !!screenshotCfg?.enabled && (payload.severity === 'major' || payload.severity === 'blocker');
    const p: BugPayload = {
        type: 'bug',
        sessionId,
        ts: now(),
        userId: getUserIdSafe() || undefined,
        title: payload.title,
        description: payload.description,
        severity: payload.severity,
        hasCapture: !!(payload.attachments && payload.attachments.length > 0),
        purpose: 'diagnostics'
    };
    if (shouldCapture) {
        const dataUrl = captureScreenshotFromTag({
            selector: screenshotCfg?.selector ?? '[data-poulet-screenshot]',
            maxBytes: screenshotCfg?.maxBytes ?? 1_000_000,
            mime: screenshotCfg?.mime ?? 'image/jpeg',
            quality: screenshotCfg?.quality ?? 0.85,
            minQuality: screenshotCfg?.minQuality ?? 0.5,
        });
        if (dataUrl) {
            p.screenshotB64 = dataUrl;
            p.hasCapture = true;
        }
    }
    enqueue(p);
    // NOTE: upload des pièces jointes = hors scope core (peut passer par un autre endpoint)
}
